function formatCurrency(amountInCents) {
  const currencySymbol = 'MXN'; // Símbolo de moneda para pesos mexicanos

  const amountInPesos = amountInCents / 100; // Convertir centavos a pesos
  const formattedAmount = amountInPesos.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });

  return formattedAmount + ' ' + currencySymbol;
}

